import {useHead} from '@vueuse/head'
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";
import router from '@/router'

const convertHtmlToText = (htmlContent) => {
    if (htmlContent == undefined) {
        return ''
    }
    return htmlContent.replace(/<[^>]+>/g, '')
}

const setKeywords = (content) => {
    let items = []
    content.keywords.forEach(item => {
        items.push(item.keyword)
    })
    items = items.join(',')
    return items
}

const validaRoutesToSetSeo = [
    'SinglePage',
    'SinglePost',
    'SingleLesson',
    'Product',
    'Login',
    'Register',
    'ForgetPassword',
    'CellphoneResetPassword',
    'VerifiedCellphone',
    'ShoppingCart',
    'UnAuthenticatedShoppingCart',

]

const getRouteName = () => {
    return router.currentRoute.value.name
}

const contentToFullPath = (content, type) => {
    const contentRoute = getRouteName()
    const hostName = `${window.location.protocol}//${window.location.hostname}`;
    let route = ''
    if (type !== 'product') {
        route = router.resolve({name: contentRoute, params: {slug: content.slug}}).href
    } else {
        route = router.resolve({name: contentRoute, params: {link: content.raw_link}}).href
    }
    return `${hostName}${route}`
}


export const config = (content, type) => {
    let config = {}
    switch (type) {
        case 'content':
            config = {
                title: content.title,
                meta: [
                    {
                        name: 'robots',
                        content: 'max-image-preview:large',
                    },
                    {
                        name: 'description',
                        content: convertHtmlToText(content.abstraction)
                    },
                    {
                        name: 'keywords',
                        content: setKeywords(content)
                    },
                    {
                        property: 'og:site_name',
                        content: findAttributeOnSiteInfo('site_name')[0]
                    },
                    {
                        property: 'og:title',
                        content: content.title
                    },
                    {
                        property: 'og:url',
                        content: contentToFullPath(content, type),
                    },
                    {
                        property: 'og:description',
                        content: convertHtmlToText(content.abstraction).slice(0, 65)
                    },
                    {
                        property: 'og:type',
                        content: 'article'
                    },
                    /*{
                        property: 'og:locale',
                        content: 'fa_IR' // todo should be language of content (fetch it from content)
                    },*/
                    {
                        property: 'og:image',
                        content: content.thumbnail
                    },
                    {
                        name: 'twitter:site',
                        content: findAttributeOnSiteInfo('site_name')[0],
                    },
                    {
                        name: 'twitter:card',
                        content: 'summary'
                    },
                    {
                        name: 'twitter:title',
                        content: content.title
                    },
                    {
                        name: 'twitter:image:src',
                        content: content.thumbnail
                    },
                    {
                        name: 'twitter:url',
                        content: contentToFullPath(content, type)
                    },
                ],
                link: [
                    {
                        rel: 'canonical',
                        href: contentToFullPath(content, type)
                    }
                ]
            }
            break;
        case 'product':
            config = {
                title: content.name,
                meta: [
                    {
                        name: 'robots',
                        content: 'max-image-preview:large',
                    },
                    {
                        name: 'description',
                        content: convertHtmlToText(content.description)
                    },
                    {
                        name: 'keywords',
                        content: setKeywords(content)
                    },
                    {
                        property: 'og:site_name',
                        content: findAttributeOnSiteInfo('site_name')[0]
                    },
                    {
                        property: 'og:title',
                        content: content.name
                    },
                    {
                        property: 'og:url',
                        content: contentToFullPath(content, type),
                    },
                    {
                        property: 'og:description',
                        content: convertHtmlToText(content.description).slice(0, 65)
                    },
                    {
                        property: 'og:type',
                        content: 'product'
                    },
                    /*{
                        property: 'og:locale',
                        content: 'fa_IR' // todo should be language of content (fetch it from content)
                    },*/
                    {
                        property: 'og:image',
                        content: content.thumbnail
                    },
                    {
                        name: 'twitter:site',
                        content: findAttributeOnSiteInfo('site_name')[0],
                    },
                    {
                        name: 'twitter:card',
                        content: 'summary'
                    },
                    {
                        name: 'twitter:title',
                        content: content.name
                    },
                    {
                        name: 'twitter:image:src',
                        content: content.thumbnail
                    },
                    {
                        name: 'twitter:url',
                        content: contentToFullPath(content, type)
                    },
                ],
                link: [
                    {
                        rel: 'canonical',
                        href: contentToFullPath(content, type)
                    }
                ]
            }
            break;
        case 'home':
            config = {
                title: findAttributeOnSiteInfo('site_name')[0],
                meta: [
                    {
                        name: 'robots',
                        content: 'max-image-preview:large',
                    },
                    {
                        name: 'description',
                        content: findAttributeOnSiteInfo('slogan')[0]
                    },
                    {
                        property: 'og:site_name',
                        content: findAttributeOnSiteInfo('site_name')[0]
                    },
                    {
                        property: 'og:title',
                        content: findAttributeOnSiteInfo('site_name')[0]
                    },
                    {
                        property: 'og:url',
                        content: window.location.origin,
                    },
                    {
                        property: 'og:description',
                        content: findAttributeOnSiteInfo('slogan')[0]
                    },
                    {
                        property: 'og:type',
                        content: 'website'
                    },
                    /*{
                        property: 'og:locale',
                        content: 'fa_IR' // todo should be language of content (fetch it from content)
                    },*/
                    {
                        property: 'og:image',
                        content: findAttributeOnSiteInfo('icon')[0]
                    },
                    {
                        name: 'twitter:site',
                        content: findAttributeOnSiteInfo('site_name')[0],
                    },
                    {
                        name: 'twitter:card',
                        content: 'summary'
                    },
                    {
                        name: 'twitter:title',
                        content: findAttributeOnSiteInfo('site_name')[0]
                    },
                    {
                        name: 'twitter:image:src',
                        content: findAttributeOnSiteInfo('icon')[0]
                    },
                    {
                        name: 'twitter:url',
                        content: window.location.origin
                    },
                ],
                link: [
                    {
                        rel: 'canonical',
                        href: window.location.origin
                    }
                ]
            }
            break;
        case 'login':
        case 'register':
        case 'forget-password':
        case 'cellphone-reset-password':
        case 'verified-cellphone':
        case 'shopping-cart':
        case 'un-authenticated-shopping-cart':
            config = {
                meta: [
                    {
                        name: 'robots',
                        content: 'noindex',
                    },
                ],
                link: [
                    {
                        rel: 'canonical',
                        href: `${window.location.origin}${window.location.pathname}`
                    }
                ]
            }
            break;
        default:
            config = {}
            break;
    }
    return config
}

export const appendTagsToPage = (content, type) => {
    useHead(config(content, type))
}

export const setSeoOnWrapper = (content, type) => {
    if (validaRoutesToSetSeo.indexOf(getRouteName()) > -1 || process.env.NODE_ENV === 'development') {
        appendTagsToPage(content, type)
    }
}